import React, { useState, useEffect, useRef } from 'react';
import './EmployeeOnboarding.css';
import Select from 'react-select';
//import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import { onboardingEmployeeVerfication, onboardingEmployesFetch } from '../../../services/onBoardingEmployeesService';
import { getAuditLog } from '../../../utils/calculateDaysInMonthUtils';
import { selectStyles } from '../../../assets/Styles/selectStyle';

const EmployeeOnboarding = () => {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [employeeName, setEmployee] = useState(null); // Holds employeeUniqueId
  const [selectedEmployee, setSelectedEmployee] = useState(null); // Holds full selected option
  const [designation, setDesignation] = useState('');
  const [employeeUniqueId, setemployeeUniqueId] = useState('');
  const [education, setEducation] = useState('');
  const [experience, setExperience] = useState('');
  const [joiningDate, setJoiningDate] = useState('');
  const [isFocused, setIsFocused] = useState({ joiningDate: false });
  const [isJoiningToday, setIsJoiningToday] = useState(null);
  const dateInputRef = useRef(null);
  const effectRan = useRef(false);
  const [documents, setDocuments] = useState({
    identity: false,
    address: false,
    photos: false,
    bank: false,
  });
  const [educationDocs, setEducationDocs] = useState({
    ssc: false,
    intermediate: false,
    graduation: false,
    postGraduation: false,
  });
  const [employmentDocs, setEmploymentDocs] = useState({
    relieving: false,
    experienceCerts: false,
    salarySlips: false,
    form16: false,
  });
  const [hrFormalities, setHrFormalities] = useState({
    joiningForm: false,
    ageAbove18: false,
    contract: false,
    nda: false,
    policies: false,
  });
  const [itFormalities, setItFormalities] = useState({
    email: false,
    laptop: false,
    biometric: false,
  });
  const [induction, setInduction] = useState({
    intro: false,
    training: false,
  });
  const [compliance, setCompliance] = useState({
    pf: false,
    esic: false,
    medical: false,
  });

  const handleDateInputClick = () => {
    dateInputRef.current?.showPicker();
  };
  const fetchEmployees = async () => {
    try {
      // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/personal-info/status?status=APPROVED`);

      // const data = response.data;

      const data = await onboardingEmployesFetch();

      if (Array.isArray(data)) {
        setEmployees(
          data.map((item) => {
            const info = item.personalInformation;
            return {
              value: info.employeeUniqueId,
              label: `${info.fullName} - ${info.employeeUniqueId}`,
              raw: info,
            };
          })
        );
      }
    } catch (error) {
      console.error('Error fetching employees:', error);
    }
  };
  useEffect(() => {
    if (effectRan.current == false) {
      fetchEmployees();
    }
    return () => {
      effectRan.current = true;
    }

  }, []);

  const handleInputChange = (selectedOption) => {
    if (!selectedOption) {
      setEmployee(null);
      setSelectedEmployee(null);
      setemployeeUniqueId('');
      setDesignation('');
      setEducation('');
      setExperience('');
      return;
    }

    setEmployee(selectedOption.value); // Set employeeName to employeeUniqueId
    setSelectedEmployee(selectedOption);
    setemployeeUniqueId(selectedOption.raw.employeeUniqueId || '');

    const info = selectedOption.raw;

    // 1. Designation
    setDesignation(info?.designation || '');

    // 2. Education (latest one by yearOfPassing)

    setEducation(info?.latestQualificationName)
    // if (info.educations?.length > 0) {
    //   const latestEdu = [...info.educations].sort(
    //     (a, b) => Number(b.yearOfPassing) - Number(a.yearOfPassing)
    //   )[0];
    //   setEducation(
    //     `${latestEdu.latestQualificationName || ''} - ${latestEdu.degreeType?.degreeType || ''
    //     } (${latestEdu.yearOfPassing})`
    //   );
    // } else {
    //   setEducation('');
    // }

    // 3. Experience (calculate total months/years)
    setExperience((info?.totalExperienceYears ?? 0).toFixed(1));

    // if (info.experiences?.length > 0) {
    //   let totalMonths = 0;
    //   info.experiences.forEach((exp) => {
    //     const from = exp.fromDate ? new Date(exp.fromDate) : null;
    //     const to = exp.toDate ? new Date(exp.toDate) : new Date(); // Current date if toDate is null

    //     if (from && !isNaN(from.getTime())) { // Only proceed if fromDate is valid
    //       if (to && !isNaN(to.getTime())) { // Only proceed if toDate is valid
    //         const months = (to.getFullYear() - from.getFullYear()) * 12 + (to.getMonth() - from.getMonth());
    //         totalMonths += months > 0 ? months : 0;
    //       }
    //     }
    //   });

    //   const years = (totalMonths / 12).toFixed(1);
    //   setExperience(`${years} years`);
    // } else {
    //   setExperience('0 years');
    // }

  };

  const handleTodayChange = (value) => {
    setIsJoiningToday(value);
    if (value === 'yes') {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const formatted = today.toLocaleDateString('en-CA');
      setJoiningDate(formatted);
    } else {
      setJoiningDate('');
    }
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  const isFormValid = () => {
    return (
      employeeName && // Added employeeName validation
      joiningDate &&
      documents.identity &&
      documents.address &&
      documents.photos &&
      documents.bank &&
      educationDocs.ssc &&
      hrFormalities.joiningForm &&
      hrFormalities.ageAbove18 &&
      hrFormalities.policies
    );
  };

  const handleSave = async () => {
    if (!isFormValid()) {
      alert('Please complete all mandatory fields.');
      return;
    }
    const fullName = localStorage.getItem('full_name');
    const role = localStorage.getItem('role');
    const employeeId = localStorage.getItem('employeeId');
    const payload = {
      employeeUniqueId: employeeUniqueId,
      fullName: employees.find((e) => e.value === employeeName)?.label.split(' - ')[0] || '',
      designation: designation,
      designationId: selectedEmployee?.raw?.employee?.jobPosition?.id || null,
      education: education,
      yearsOfExperience: parseFloat(experience) || 0,
      proofOfIdentity: documents.identity,
      proofOfAddress: documents.address,
      passportPhotos: documents.photos,
      bankDetails: documents.bank,
      sscCertificate: educationDocs.ssc,
      intermediateDiploma: educationDocs.intermediate,
      graduation: educationDocs.graduation,
      postGraduation: educationDocs.postGraduation,
      relievingLetter: employmentDocs.relieving,
      experienceCertificates: employmentDocs.experienceCerts,
      last3MonthsPayslips: employmentDocs.salarySlips,
      form16OrTaxDetails: employmentDocs.form16,
      joiningForm: hrFormalities.joiningForm,
      above18: hrFormalities.ageAbove18,
      contractSigned: hrFormalities.contract,
      ndaSigned: hrFormalities.nda,
      policiesAcknowledged: hrFormalities.policies,
      emailCreated: itFormalities.email,
      laptopIssued: itFormalities.laptop,
      biometricRegistered: itFormalities.biometric,
      introducedToManager: induction.intro,
      functionalTraining: induction.training,
      pfNominated: compliance.pf,
      esicEnrolled: compliance.esic,
      professionalTaxRegistered: false,
      medicalInsurence: compliance.medical,
      joiningToday: isJoiningToday === 'yes',
      joiningDate: isJoiningToday === 'no' ? joiningDate : null,
    };
    if (employeeId && role) {
      // payload.auditLog = {
      //   name: fullName,
      //   role: role,
      //   employeeId: employeeId,
      // };
      payload.auditLog = getAuditLog();
    }
    try {
      //const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/documents-verification`,payload);
      const response = await onboardingEmployeeVerfication(payload);
      console.log('Saved successfully:', response.data);
      alert('Onboarding saved successfully!');
      handleClear();
      fetchEmployees();
    } catch (err) {
      console.error('Error saving onboarding:', err);
      alert('Error while saving onboarding');
    }
  };

  const handleClear = () => {
    setEmployee(null);
    setSelectedEmployee(null);
    setemployeeUniqueId('');
    setDesignation('');
    setEducation('');
    setExperience('');
    setJoiningDate('');
    setIsJoiningToday(null);
    setDocuments({
      identity: false,
      address: false,
      photos: false,
      bank: false,
    });
    setEducationDocs({
      ssc: false,
      intermediate: false,
      graduation: false,
      postGraduation: false,
    });
    setEmploymentDocs({
      relieving: false,
      experienceCerts: false,
      salarySlips: false,
      form16: false,
    });
    setHrFormalities({
      joiningForm: false,
      ageAbove18: false,
      contract: false,
      nda: false,
      policies: false,
    });
    setItFormalities({
      email: false,
      laptop: false,
      biometric: false,
    });
    setInduction({
      intro: false,
      training: false,
    });
    setCompliance({
      pf: false,
      esic: false,
      medical: false,
    });
    setIsFocused({ joiningDate: false });
  };

  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    return tomorrow;
  };

  const isNotSunday = (date) => {
    return date.getDay() !== 0;
  };

  return (
    <div className="onboard-maincontainer">
      <div className="onboard-box">
        <h2 className="onboard-heading">Employee Onboarding</h2>
        <div className="onboard-structure-heading">
          <div className="onboard-maincontainer-1">
            <div className="onboard-container-part">
              <div className={`onboard-floating-label-container-2 ${selectedEmployee ? 'float-label' : ''}`}>
                <Select
                  name="employeeName"
                  options={employees}
                  value={selectedEmployee}
                  onChange={handleInputChange}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  // styles={{
                  //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  //   menu: (base) => ({ ...base, marginTop: '5px', zIndex: 9999 }),
                  //   control: (provided) => ({ ...provided, padding: '1px' }),
                  //   valueContainer: (provided) => ({ ...provided, padding: '3px 6px' }),
                  // }}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>Employee Name
                </label>
              </div>
            </div>
            <div className="onboard-container-part">
              <div className="onboard-floating-label-container-2">
                <input
                  type="text"
                  name="designation"
                  value={designation}
                  readOnly
                  placeholder=" "
                  required
                />
                <label>Designation</label>
              </div>
            </div>
          </div>

          <div className="onboard-maincontainer-1">
            <div className="onboard-container-part">
              <div className="onboard-floating-label-container-2">
                <input
                  type="text"
                  name="education"
                  value={education}
                  onChange={(e) => setEducation(e.target.value)}
                  placeholder=" "
                  required
                />
                <label>Education</label>
              </div>
            </div>
            <div className="onboard-container-part">
              <div className="onboard-floating-label-container-2">
                <input
                  type="text"
                  name="experience"
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                  placeholder=" "
                  required
                />
                <label>Year of Experience</label>
              </div>
            </div>
          </div>

          <div className="onboard-maincontainer-1">
            <div className="onboard-container-part">
              <div className="radio-group">
                <label>
                  <span className="required">*</span>Joining today ?
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input
                    type="radio"
                    value="yes"
                    checked={isJoiningToday === 'yes'}
                    onChange={() => handleTodayChange('yes')}
                  />
                  &nbsp;Yes&nbsp;&nbsp;&nbsp;&nbsp;
                </label>
                <label>
                  <input
                    type="radio"
                    value="no"
                    checked={isJoiningToday === 'no'}
                    onChange={() => handleTodayChange('no')}
                  />
                  &nbsp;No
                </label>
              </div>
            </div>

            <div className="onboard-container-part">
              {isJoiningToday === 'no' && (
                <div
                  className={`onboard-floating-label-container-2 ${isFocused.joiningDate || joiningDate ? 'float-label' : ''
                    }`}
                >
                  <DatePicker
                    ref={dateInputRef}
                    selected={
                      joiningDate
                        ? new Date(
                          joiningDate.split('-')[0],
                          joiningDate.split('-')[1] - 1,
                          joiningDate.split('-')[2]
                        )
                        : null
                    }
                    onChange={(date) => {
                      if (date) {
                        const localDate = new Date(date);
                        localDate.setHours(0, 0, 0, 0);
                        const formatted = localDate.toLocaleDateString('en-CA');
                        setJoiningDate(formatted);
                      } else {
                        setJoiningDate('');
                      }
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText=""
                    minDate={getTomorrowDate()}
                    filterDate={isNotSunday}
                    className="did-floating-input-on"
                    onFocus={() => setIsFocused({ ...isFocused, joiningDate: true })}
                    onBlur={() => setIsFocused({ ...isFocused, joiningDate: false })}
                  />
                  <label>
                    <span className="required">*</span>Joining Date
                  </label>
                </div>
              )}

              {isJoiningToday === 'yes' && (
                <div className="onboard-floating-label-container-2 float-label">
                  <input
                    type="text"
                    value={
                      joiningDate
                        ? new Date(joiningDate).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                        }).split('/').join('-')
                        : ''
                    }
                    readOnly
                    className="did-floating-input-on"
                    disabled
                  />
                  <label>
                    <span className="required">*</span>Joining Date
                  </label>
                </div>
              )}
            </div>
          </div>

          <div className="onboard-header">Joining Formalities Checklist</div>
          <table className="styled-table">
            <thead>
              <tr>
                <th>S. No</th>
                <th>Documents Collection</th>
                <th>Verified</th>
              </tr>
            </thead>
            <tbody className="onboard-tbody">
              <tr>
                <td>1</td>
                <td>
                  <span className="required">*</span>Proof of identity (PAN, Voter Id, Aadhaar)
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={documents.identity}
                    onChange={(e) => setDocuments({ ...documents, identity: e.target.checked })}
                  />
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <span className="required">*</span>Proof of address (Aadhaar)
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={documents.address}
                    onChange={(e) => setDocuments({ ...documents, address: e.target.checked })}
                  />
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  <span className="required">*</span>Passport-size photographs (2)
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={documents.photos}
                    onChange={(e) => setDocuments({ ...documents, photos: e.target.checked })}
                  />
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>
                  <span className="required">*</span>Bank passbook / cheque
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={documents.bank}
                    onChange={(e) => setDocuments({ ...documents, bank: e.target.checked })}
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <table className="styled-table">
            <thead>
              <tr>
                <th>S. No</th>
                <th>Education Documents</th>
                <th>Verified</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <span className="required">*</span>SSC certificate
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={educationDocs.ssc}
                    onChange={(e) => setEducationDocs({ ...educationDocs, ssc: e.target.checked })}
                  />
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>Intermediate / Diploma</td>
                <td>
                  <input
                    type="checkbox"
                    checked={educationDocs.intermediate}
                    onChange={(e) =>
                      setEducationDocs({ ...educationDocs, intermediate: e.target.checked })
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>Graduation</td>
                <td>
                  <input
                    type="checkbox"
                    checked={educationDocs.graduation}
                    onChange={(e) =>
                      setEducationDocs({ ...educationDocs, graduation: e.target.checked })
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>Post Graduation</td>
                <td>
                  <input
                    type="checkbox"
                    checked={educationDocs.postGraduation}
                    onChange={(e) =>
                      setEducationDocs({ ...educationDocs, postGraduation: e.target.checked })
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <table className="styled-table">
            <thead>
              <tr>
                <th>S. No</th>
                <th>Employment Documents</th>
                <th>Verified</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Relieving letter</td>
                <td>
                  <input
                    type="checkbox"
                    checked={employmentDocs.relieving}
                    onChange={(e) =>
                      setEmploymentDocs({ ...employmentDocs, relieving: e.target.checked })
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>Experience certificates</td>
                <td>
                  <input
                    type="checkbox"
                    checked={employmentDocs.experienceCerts}
                    onChange={(e) =>
                      setEmploymentDocs({ ...employmentDocs, experienceCerts: e.target.checked })
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>Last 3 months salary slips</td>
                <td>
                  <input
                    type="checkbox"
                    checked={employmentDocs.salarySlips}
                    onChange={(e) =>
                      setEmploymentDocs({ ...employmentDocs, salarySlips: e.target.checked })
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>Form 16/Tax details</td>
                <td>
                  <input
                    type="checkbox"
                    checked={employmentDocs.form16}
                    onChange={(e) =>
                      setEmploymentDocs({ ...employmentDocs, form16: e.target.checked })
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <table className="styled-table">
            <thead>
              <tr>
                <th>S. No</th>
                <th>HR/Administration Formalities</th>
                <th>Verified</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <span className="required">*</span>Filling of joining form / personal information
                  form
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={hrFormalities.joiningForm}
                    onChange={(e) =>
                      setHrFormalities({ ...hrFormalities, joiningForm: e.target.checked })
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <span className="required">*</span>Age Above 18 years
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={hrFormalities.ageAbove18}
                    onChange={(e) =>
                      setHrFormalities({ ...hrFormalities, ageAbove18: e.target.checked })
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>Signing of employment contract / appointment letter</td>
                <td>
                  <input
                    type="checkbox"
                    checked={hrFormalities.contract}
                    onChange={(e) =>
                      setHrFormalities({ ...hrFormalities, contract: e.target.checked })
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>NDA / confidentiality agreement</td>
                <td>
                  <input
                    type="checkbox"
                    checked={hrFormalities.nda}
                    onChange={(e) => setHrFormalities({ ...hrFormalities, nda: e.target.checked })}
                  />
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>
                  <span className="required">*</span>Company policies acknowledgment (Code of Conduct,
                  Leave, Dress Code, etc.)
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={hrFormalities.policies}
                    onChange={(e) =>
                      setHrFormalities({ ...hrFormalities, policies: e.target.checked })
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <table className="styled-table">
            <thead>
              <tr>
                <th>S. No</th>
                <th>IT / System Access Formalities</th>
                <th>Verified</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Email account creation</td>
                <td>
                  <input
                    type="checkbox"
                    checked={itFormalities.email}
                    onChange={(e) => setItFormalities({ ...itFormalities, email: e.target.checked })}
                  />
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>Laptop/desktop and accessories issuance</td>
                <td>
                  <input
                    type="checkbox"
                    checked={itFormalities.laptop}
                    onChange={(e) => setItFormalities({ ...itFormalities, laptop: e.target.checked })}
                  />
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>Biometric / Attendance registration</td>
                <td>
                  <input
                    type="checkbox"
                    checked={itFormalities.biometric}
                    onChange={(e) =>
                      setItFormalities({ ...itFormalities, biometric: e.target.checked })
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <table className="styled-table">
            <thead>
              <tr>
                <th>S. No</th>
                <th>Induction & Orientation</th>
                <th>Verified</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Introduction to reporting manager and team</td>
                <td>
                  <input
                    type="checkbox"
                    checked={induction.intro}
                    onChange={(e) => setInduction({ ...induction, intro: e.target.checked })}
                  />
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>Functional training / role-based induction</td>
                <td>
                  <input
                    type="checkbox"
                    checked={induction.training}
                    onChange={(e) => setInduction({ ...induction, training: e.target.checked })}
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <table className="styled-table">
            <thead>
              <tr>
                <th>S. No</th>
                <th>Compliance & Benefits Enrollment</th>
                <th>Verified</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Provident Fund</td>
                <td>
                  <input
                    type="checkbox"
                    checked={compliance.pf}
                    onChange={(e) => setCompliance({ ...compliance, pf: e.target.checked })}
                  />
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>ESIC enrollment (if applicable)</td>
                <td>
                  <input
                    type="checkbox"
                    checked={compliance.esic}
                    onChange={(e) => setCompliance({ ...compliance, esic: e.target.checked })}
                  />
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>Medical Insurance</td>
                <td>
                  <input
                    type="checkbox"
                    checked={compliance.medical}
                    onChange={(e) => setCompliance({ ...compliance, medical: e.target.checked })}
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <div className="onboard-btn-div">
            <button type="button" className="onboard-cancel" onClick={handleCancel}>
              Cancel
            </button>
            <button type="button" className="onboard-clear" onClick={handleClear}>
              Clear
            </button>
            <button
              type="button"
              className="onboard-btn"
              onClick={handleSave}
              disabled={!isFormValid()}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeOnboarding;